import { queryKeys, routes, TEXT_STRING } from '../../../constants';
import { useEffect, useRef, useState } from 'react';
import { getPremiumPurchasedList } from 'api';
import { PostContext } from 'contexts';
import PostView from 'pages/Home/PostView';
import { Header } from 'components';
import { useNavigate, useLocation } from 'react-router-dom';


function PremiumPurchased() {
  // Hooks
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const location = useLocation();

  // State
  const [galleryWidth, setGalleryWidth] = useState<number | undefined>(
    undefined,
  );

  useEffect(() => {
    if (ref.current?.offsetWidth && galleryWidth !== ref.current?.offsetWidth) {
      setGalleryWidth(ref.current.offsetWidth);
    }
  }, [galleryWidth, setGalleryWidth]);

  return (
    <PostContext.Provider value={{ galleryWidth, setGalleryWidth }}>
      <div ref={ref} className="h-full overflow-y-auto flex flex-col w-full">
        <Header
          title={TEXT_STRING.MY_PAGE.PURCHASED_PAID_TWEET}
          onBack={() => {
            location?.state?.isFinish
              ? navigate(routes.HOME, { replace: true })
              : navigate(-1);
          }}
        />
        <div className={`flex gap-3 bg-primary h-0 px-4`}>
          <div className={`flex-[1]`}></div>
          <div className={`flex-[7]`} ref={ref}></div>
        </div>
        <PostView
          getPostList={getPremiumPurchasedList}
          queryKey={[queryKeys.POST_PURCHASED]}
          enabled
          customScrollParent={ref.current}
        />
      </div>
    </PostContext.Provider>
  );
}

export default PremiumPurchased;
